<script>
import axios from "axios";
//import {useRouter} from "vue-router";
import { debug, api } from "../../server.json";
import * as $ from "jquery";
import Monitor from "@/views/Monitor.vue";
import Swal from "sweetalert2";

const $api = "http://147.79.83.124:8081/api";
export default {
  name: "Helper",
  api: api,
  checkLogin: function () {
    let jwt = sessionStorage.getItem("jwt");
    if (jwt === null || jwt === undefined || jwt === "") {
      return false;
    }

    return true;
  },
  checkPermissions() {
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) {
      $("#link-sistema").hide();
      $("#navbar-links").hide();
      return;
    }

    if (user.admin !== true) {
      $("#link-sistema").hide();

      //Monitor.showCharts = true
      //this.$router.push("/monitor")
    }

    if (user.admin === true) {
      $("#module-inventory").removeClass("d-none");
    }
    if (user.readonly) {
      $("#navbar-links").hide();
      return;
    }

    if (user.profile.toLowerCase() === "operacional") {
      $("#navbar-links").hide();
      //this.$router.push("/lista-os")
    } else {
      if (user.profile.toLowerCase() === "monitor") {
        $("#link-gerencia").hide();
        $("#link-lista-os").hide();
      }

      //this.$router.push("/monitor")
    }
  },
  axiosRequest: function (
    $config = {
      method: "get",
      url: "",
      body: {},
      headers: {},
      addAuth: true,
      onSuccess: function ($r) {
        console.log($r);
      },
      onFail: function ($err) {
        console.log($err);
        alert("Erro inesperado");
      },
    },
  ) {
    let $url = api + $config.url;

    if (debug) {
      console.log("chamando " + $config.url);
    }

    if ($url === api) {
      console.log("URL incorreta");
      return;
    }

    let $method = $config.method;
    if ($method === undefined) {
      $method = "get";
    }

    let $body = $config.body;
    if ($body == undefined) {
      $body = {};
    }

    let $headers = $config.headers;
    if ($headers == undefined) {
      $headers = {};
    }

    let $addAuth = $config.addAuth;
    if ($addAuth == undefined) {
      $addAuth = true;
    }

    let $onSuccess = $config.onSuccess;
    if ($onSuccess === undefined) {
      $onSuccess = function ($r) {
        console.log($r);
      };
    }

    let $onFail = $config.onFail;
    if ($onFail === undefined) {
      $onFail = function ($r) {
        //this.alertError("Ocorreu um erro durante a requisição");
        //console.log($r);
        /*if( $r.status === 403 ) {
          Swal.fire({
            icon: "info",
            title: "Login inválido",
            html: "É preciso fazer o login novamente para continuar",
          })
        }*/
      };
    }

    if ($addAuth) {
      $headers["authorization"] = "Bearer " + sessionStorage.getItem("jwt");
    }

    axios({
      method: $method,
      url: $url,
      headers: $headers,
      data: $body,
      responseType: "json",
    })
      .then(function (response) {
        $onSuccess(response);
      })
      .catch(function (err) {
        $onFail(err);
      });
  },

  // App Variables
  callOsList: false,
  callMonitorList: false,
  request: {
    osCall: {
      registered: false,
      make: false,
    },
    Monitor: {
      registered: false,
      make: false,
    },
    MonitorWait: {
      registered: false,
      make: false,
    },
    notificationCall: {
      registered: false,
      make: false,
    },
    dailyMonitoring: {
      registered: false,
      make: false,
    },
    checkTime: {
      registered: false,
      make: false,
    },
  },
};
</script>

<template></template>

<style scoped></style>
